import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Results from './pages/Results';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import NotFound from './pages/NotFound';
import CookieBanner from './components/common/CookieBanner';

function App() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Helmet>
        <title>NuPitch Incentive Match Maker - Film Tax Credits & Rebates</title>
        <meta name="description" content="Upload your script or paste your film idea. Get instant matches to global tax credits and rebates in seconds. Free, no account needed." />
      </Helmet>
      
      <Header />
      
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/results/:submissionId" element={<Results />} />
          <Route path="/share/:shareToken" element={<Results isShared={true} />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      
      <Footer />
      <CookieBanner />
    </div>
  );
}

export default App;